import { render, staticRenderFns } from "./concept.vue?vue&type=template&id=4fa1757f&scoped=true&"
import script from "./concept.js?vue&type=script&lang=js&"
export * from "./concept.js?vue&type=script&lang=js&"
import style0 from "../overview.scss?vue&type=style&index=0&id=4fa1757f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa1757f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fa1757f')) {
      api.createRecord('4fa1757f', component.options)
    } else {
      api.reload('4fa1757f', component.options)
    }
    module.hot.accept("./concept.vue?vue&type=template&id=4fa1757f&scoped=true&", function () {
      api.rerender('4fa1757f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/AudienceManager/Components/Overview/Concept/concept.vue"
export default component.exports